<div class="container">
    <div class="row">
        <div class="col-12">
            <h1 class="mt-5">
                Loading User Preferences...
            </h1>
        </div>
    </div>
    <div class="row">
        <div *ngIf="errorHandler.error | async" class="col-12">
            <response-error [model]="errorHandler.error | async"></response-error>
        </div>
    </div>
</div>
